import { Record } from 'immutable'

export class UserRole extends Record({
    id: undefined,
    name: undefined,
    users_count: undefined,
    user_permission_ids: [],
    routes: [],
}) {}
